/**
 * @description: 客户端类型
 */
const APP_PLATFORM = {
  'ANDROID_PHONE': { key: 10, name: 'Android手机',downType: 1 },
  'IOS_PHONE': { key: 20, name: 'IOS手机',downType: 2 },
  'PC_32': { key: 32, name: 'PC客户端' ,downType: 3},
  'MAC': { key: 33, name: 'MAC客户端' ,downType: 4},
  'PC_64': { key: 64, name: 'PC客户端64位' ,downType: 5},
  'WORK': { key: 99, name: '工作台' ,downType: 1},
  'LIVE': { key: 100, name: '直播翻译平台' },
  'LIVE_MAC':{key:210,name:'直播同传-MAC客户端',downType: 210},
  'LIVE_WIN':{key:220,name:'直播同传-WIN客户端',downType: 220},
  'LIVE_LINUX':{key:230,name:'直播同传-LINUX客户端',downType: 230},
  'LIVE_ANDROID':{key:240,name:'直播同传-Android手机',downType: 240},
  'LIVE_IOS':{key:250,name:'直播同传-IOS手机',downType: 250},
}
/**
 * @description:
 */
const VERSION_LOG = {
  'PC': { key: 10, name: '译视界电脑端' },
  'WORK': { key: 20, name: '译视界工作台' },
  'APP': { key: 30, name: '译视界APP' },
  'LIVE': { key: 40, name: '译视界直播同传' },
}
/**
 * @description: 管理系统菜单类型
 */
const MENU_TYPE = {
  'MENU': { key: 1, name: '菜单' },
  'ROUTING_ONLY': { key: 2, name: '仅路由' },
}

export default {
  APP_PLATFORM,
  VERSION_LOG,
  MENU_TYPE,
}



// WEBPACK FOOTER //
// ./src/utils/constUtil.js